import React from "react";
import PropTypes from "prop-types";

const ThankYou = props => {
  const {
    employee,
    submittedText: { thankYou, confirmation, disclaimer, confirmationID },
  } = props;

  return (
    <div className="padding-bottom-10">
      <div className="thank-you">
        <div className="wrapper">
          <div className="title">{employee.location.employer.name}</div>
          <div className="message">{thankYou}</div>
          <div className="message">
            {confirmation} <span className="employee-id">{employee.id}</span>
          </div>
          <div className="message-small">
            {disclaimer}
            <strong style={{ fontWeight: 500 }}>{confirmationID}</strong>.
          </div>
        </div>
      </div>
    </div>
  );
};

ThankYou.propTypes = {
  employee: PropTypes.object,
  submittedText: PropTypes.object.isRequired,
};

export default ThankYou;



// WEBPACK FOOTER //
// ./src/components/ThankYou.js